module.exports = (__webpack_require__(2))(66);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/MetadataMixin.js from dll-reference girder_lib
// module id = 47
// module chunks = 0